export const environment = {
  appName: 'Handyhand',
  appUrl: 'https://handyhand.dk',
  country: 'Denmark',
  platformUrl: 'https://handyhand.dk/platform',
  production: true,
  env: 'production',
  supportEmail: 'support@handyhand.dk',
  supportPhone: '+45 93833441',
  apiUrl: 'https://api.handyhand.dk/api',
  apiV2Url: 'https://api-v2.handyhand.dk',
  vectorServiceUrl: 'https://vector.handyhand.dk/api',
  dashboardBaseRef: 'https://api-dashboard.handyhand.dk/',
  apiPrefix: '',
  resizeUrl: 'https://d3r2zfg0xujt92.cloudfront.net',
  cloudFrontImgUrl: 'https://d10a6kin4dgxel.cloudfront.net',
  domain: 'https://handyhand.dk',
  googleTagId: 'GTM-5T5GZ93',
  posthog: {
    key: 'phc_Rcp6yZsVSZbc4O2NxGweWpo3UNjc1CkPY3FCZZLjF6O',
    host: 'https://i.handyhand.dk',
  },
  social: {
    fb: 'https://da-dk.facebook.com/ahandyhand',
    instagram: 'https://www.instagram.com/handyhand.dk/',
    linkedin: 'https://dk.linkedin.com/company/handy-hand',
  },
};
